/**
 * Iniciais para o placeholder do avatar. Nota: comportamento de fallback difere do
 * `getInitials` de profileHelpers.ts (aqui, nome de uma palavra só usa 1 letra + 'U'
 * como padrão; lá usa as 2 primeiras letras) — não consolidar sem revisar ambos os usos.
 */
export function getInitials(name: string): string {
  const names = name.trim().split(' ');
  if (names.length === 1) {
    return names[0]?.charAt(0).toUpperCase() || 'U';
  }
  const firstInitial = names[0]?.charAt(0) || '';
  const lastInitial = names[names.length - 1]?.charAt(0) || '';
  return (firstInitial + lastInitial).toUpperCase();
}
